import { Box, Flex, Heading, Table, Thead, Tbody, Tfoot, Tr, Th, Td, Text, Link, Divider, Button, Image, Icon, useMediaQuery } from "@chakra-ui/react";
import { useQuery } from "react-query";
import React, { useState } from "react";
import { getActivity, getBoardInfo, getBoardList } from "../../../service";
import { responsiveValue } from "../../../assets/style/defaultTheme";
import dayjs from "dayjs";
import { activityRecentPostsStyle } from "../meta";
import { MdOutlineViewList, MdOutlineViewModule } from "react-icons/md";
import { theme } from "../../../assets/style/theme";

const { flexBoxDirection, participationSideBoxWidth, participationContentBoxWidth } = responsiveValue;

type Props = {
	boardId: string;
};
function ParticipationContentItemRecentPost({ boardId }: Props) {
	const [category1, setCategory1] = useState(undefined);
	const [viewMode, setViewMode] = useState("list" as "list" | "table");

	const { isLoading, error, data } = useQuery(["ParticipationContentItemRecentPostFaq", category1], () => getBoardList(`${boardId}`, 4, 0, undefined, category1));
	const { isLoading: isLoadinBoardInfo, error: boardInfoError, data: boardInfo } = useQuery("BoardInfoFaq", () => getBoardInfo(boardId));

	const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

	const tableStyle = {
		borderTopWidth: "3px",
		borderStyle: "solid",
		borderTopColor: "b.dgr",
	};

	const tdStyle = {
		borderBottomWidth: "1px",
		borderStyle: "solid",
		borderBottomColor: "b.g",
		pt: isMobile ? "4" : "8",
		pb: isMobile ? "4" : "8",
		pl: "0",
		pr: "5",
		fontWeight: "800",
	};

	const boxStyle = {
		borderStyle: "solid",
		borderWidth: "1px",
		borderColor: "#e6e6e6",
		width: "282px",
		borderRadius: "24px",
		overflow: "hidden",
	};

	const isEnglish = window.__LANG__ === "en";

	return (
		<>
			<Divider mt="14" mb="14" color="b.lg" />
			{/* {!isLoadinBoardInfo && boardInfo && boardInfo.category1_list.length !== 0 && (
				<Box pb="10">
					{boardInfo.category1_list.split(",").map((item: any, index: number) => (
						<Button key={index} variant={category1 === item ? "solid" : "outline"} colorScheme={category1 === item ? "dgr" : "g"} mr={2} mb={2} onClick={() => setCategory1(item)}>
							{item}
						</Button>
					))}
				</Box>
			)} */}
			<Flex align="center" justify="space-between" pb="9">
				<Flex>
					<Heading size="4xl" color="b.dgr">
						FAQ
					</Heading>
					{!isMobile && (
						<Box pl={3} pr={3} mt={1}>
							<button onClick={() => setViewMode("list")}>
								<Icon as={MdOutlineViewList} w={8} h={8} color={viewMode === "list" ? "b.dgr" : "b.lg"} />
							</button>
							<button onClick={() => setViewMode("table")}>
								<Icon as={MdOutlineViewModule} w={8} h={8} color={viewMode === "table" ? "b.dgr" : "b.lg"} />
							</button>
						</Box>
					)}
				</Flex>
				<Flex>
					{boardInfo?.permission_write === "author" && (
						<Link href={`${isEnglish ? '/en' : ''}/board?board_id=${boardId}&mode=write`}>
							<Button size={isMobile ? "md" : "lg"} colorScheme="dgr" mr={3}>
								글쓰기
							</Button>
						</Link>
					)}
					<Link href={`${isEnglish ? '/en' : ''}/board?board_id=${boardId}`}>
						<Button size={isMobile ? "md" : "lg"} colorScheme="dgr">
							{ isEnglish ? 'View All' : '전체보기' }
						</Button>
					</Link>
				</Flex>
			</Flex>
			{!isLoading && !error && data && (
				<>
					{viewMode === "list" && (
						<Table variant="simple" size="lg" {...tableStyle}>
							<Tbody>
								{data.items.map((item: any, index: number) => (
									<Tr key={index}>
										<Td w={isMobile ? "100%" : "70%"} {...tdStyle} {...tdStyle}>
											<Text fontSize={isMobile ? "xl" : "2xl"} fontWeight="800" w="99%" noOfLines={1}>
												<Link href={`${isEnglish ? '/en' : ''}/board?mode=view&board_id=${boardId}&post_id=${item.uid}`} dangerouslySetInnerHTML={{ __html: item.title }}></Link>
											</Text>
										</Td>
										{!isMobile && (
											<Td fontSize="2xl" color="b.lg" whiteSpace="nowrap" {...tdStyle} textAlign="right">
												{dayjs(item.date).format("YYYY. MM. DD")}
											</Td>
										)}
									</Tr>
								))}
							</Tbody>
						</Table>
					)}
					{viewMode === "table" && (
						<Flex justify="space-between">
							{data.items.map((item: any, index: number) => (
								<Box {...boxStyle} className="item" key={index}>
									<Link href={`${isEnglish ? '/en' : ''}/board?mode=view&board_id=${boardId}&post_id=${item.uid}`}>
										<Image src={`https://koreashe.org${item.thumbnail_file}`} objectFit="cover" className="item-image" w="100%" h="250px" />
										<Box padding="6" className="item-text">
											<Flex justify="space-between" direction="column">
												<Text fontSize="lg" color="b.g" lineHeight="1.4" fontWeight="bold">
													{item.title}
												</Text>
											</Flex>
										</Box>
									</Link>
								</Box>
							))}
						</Flex>
					)}
				</>
			)}
		</>
	);
}

ParticipationContentItemRecentPost.defaultProps = {};

export default ParticipationContentItemRecentPost;
